import Vue from 'vue'
import Vuex from 'vuex'
import { FeedbackSubmitModel } from '@/models/FeedbackSubmitModel'
import { FeedbackApi } from './FeedbackApi'
import { FeedbackRequestCreateModel } from '@/models/FeedbackRequestCreateModel'
import { FeedbackTemplateModel } from '@/models/FeedbackTemplateModel'
import { FeedbackRequestCreatedModel } from '@/models/FeedbackRequestCreatedModel'
import { FeedbackRequestSharedModel } from '@/models/FeedbackRequestSharedModel'
import { FeedbackRequestOwnerModel } from '@/models/FeedbackRequestOwnerModel'
import { FeedbackResultsModel } from '@/models/FeedbackResultsModel'
import interceptors from '@/api/Interceptors'
import { PagedList } from '@/models/PagedList'

Vue.use(Vuex)

const api = new FeedbackApi(process.env.VUE_APP_BASE_API_URL /* 'https://wannagrowmeapi.appspot.com' */)
interceptors.setHttpInterceptors(api.client)

export default new Vuex.Store({
  state: {
    sharedFeedbackRequest: {} as FeedbackRequestSharedModel,
    feedbackRequest: {} as FeedbackRequestOwnerModel,
    submittedFeedbackRequest: {} as FeedbackSubmitModel,
    feedbackResults: {} as FeedbackResultsModel,
    feedbackRequestsList: {} as PagedList<FeedbackRequestOwnerModel>,
    feedbackTemplates: [] as FeedbackTemplateModel[],
    createdFeedbackRequest: {} as FeedbackRequestCreatedModel,
    identity: { idToken: null as (string | null) },
    targetRedirectUrl: null as (string | null),
    errorCode: null as (number | null)
  },
  mutations: {
    loadSharedFeedbackRequest (state, feedbackRequest: FeedbackRequestSharedModel) {
      state.sharedFeedbackRequest = feedbackRequest
    },
    loadFeedbackRequest (state, feedbackRequest: FeedbackRequestOwnerModel) {
      state.feedbackRequest = feedbackRequest
    },
    loadFeedbackTemplates (state, feedbackTemplates: FeedbackTemplateModel[]) {
      state.feedbackTemplates = feedbackTemplates
    },
    loadFeedbackResults (state, feedbackResults: FeedbackResultsModel) {
      state.feedbackResults = feedbackResults
    },
    loadFeedbackRequestsResults (state, feedbackRequestsList: PagedList<FeedbackRequestOwnerModel>) {
      state.feedbackRequestsList = feedbackRequestsList
    },
    submitFeedbackRequest (state) {
      state.submittedFeedbackRequest = {} as FeedbackSubmitModel
    },
    createdFeedbackRequest (state, createdFr: any) {
      state.createdFeedbackRequest = createdFr
    },
    setToken (state, idToken: string | null) {
      state.identity.idToken = idToken
    },
    setRedirectAfterLoginUrl (state, targetRedirectUrl: string | null) {
      state.targetRedirectUrl = targetRedirectUrl
    },
    setErrorCode (state, errorCode: number | null) {
      state.errorCode = errorCode
    }
  },
  getters: {
    // TODO: this is named the same as an already-existing property in state. delete?
    identity: (state: any) => {
      return state.identity
    },
    redirectAfterLoginUrl: (state: any) => {
      return state.targetRedirectUrl
    }
  },
  actions: {
    async getFeedbackTemplateBySharedId (context, filter: { sharedId: string }) {
      return api.getFeedbackTemplateBySharedId(filter && filter.sharedId ? filter.sharedId : undefined)
        .then((fr: FeedbackRequestSharedModel) => {
          context.commit('loadSharedFeedbackRequest', fr)
          return fr
        })
    },
    async getFeedbackTemplates (context, filter: { category?: string }) {
      return api.getFeedbackTemplates(filter.category)
        .then((fr: FeedbackTemplateModel[]) => {
          console.log('store:fr', fr)
          context.commit('loadFeedbackTemplates', fr)
          return fr
        },
        (err: any) => {
          console.log('store:err', err)
          return Promise.reject(err)
        })
    },
    async submitFeedback (context, feedbackModel: FeedbackSubmitModel) {
      return api.postFeedback(feedbackModel)
        .then(() => {
          context.commit('submitFeedbackRequest')
          return Promise.resolve()
        })
    },
    async createFeedbackRequest (context, feedbackRequest: FeedbackRequestCreateModel) {
      return api.postFeedbackRequest(feedbackRequest)
        .then((createdFr: FeedbackRequestCreatedModel) => {
          context.commit('createdFeedbackRequest', createdFr)
          return Promise.resolve(createdFr)
        })
    },
    async getFeedbackRequestById (context, feedbackRequestId: string) {
      return api.getFeedbackRequestById(feedbackRequestId)
        .then((fr: FeedbackRequestOwnerModel) => {
          context.commit('loadFeedbackRequest', fr)
          return fr
        })
    },
    async searchFeedbackRequests (context: any, filter: { pageNumber: number, pageSize: number }) {
      return api.searchFeedbackRequests(filter.pageNumber, filter.pageSize)
        .then((frList: PagedList<FeedbackRequestOwnerModel>) => {
          context.commit('loadFeedbackRequestsResults', frList)
          return frList
        },
        (err: any) => {
          return Promise.reject(err)
        })
    },
    async getFeedbackRequestAnalysis (context, feedbackRequestId: string) {
      return api.getFeedbackRequestAnalysis(feedbackRequestId)
        .then((fra: FeedbackResultsModel) => {
          context.commit('loadFeedbackResults', fra)
          return fra
        })
    },
    async setIdentity (context, idToken: string) {
      context.commit('setToken', idToken)
    },
    async syncMyUser (context) {
      return api.syncMyUser()
        .then(() => {
          console.log()
        })
    },
    getParaphrase (context, text: string) {
      return api.getParaphrase(text)
    },
    getGuid (context) {
      return api.getGuid()
    }
  },
  modules: {
  }
})
